import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import StorageLimit, { StorageLimitDeleteResult } from 'mbs-ui-shared@models/StorageLimit';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageLimitsService {
  private http = inject(HttpClient);

  private baseUrl = '/api/storageLimits';
  private jsonFormat = 'application/json; charset=utf-8';

  getLimits(): Observable<StorageLimit[]> {
    return this.http.get<StorageLimit[]>(`${this.baseUrl}`);
  }

  setLimit(newLimit: Partial<StorageLimit>): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}`, newLimit, { headers: { 'Content-Type': this.jsonFormat } });
  }

  updateLimit(newLimit: Partial<StorageLimit>): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/${newLimit.id}`, newLimit, { headers: { 'Content-Type': this.jsonFormat } });
  }

  deleteLimit(id: number, newPlanId?: number): Observable<StorageLimitDeleteResult> {
    return this.http.delete<StorageLimitDeleteResult>(`${this.baseUrl}/${id}`, { params: { newPlanId } });
  }

  hasS3Account(): Observable<boolean> {
    return this.http.get<boolean>(`${this.baseUrl}/has-s3-account`);
  }
}
